module.exports = __webpack_public_path__ + "static/img/champ-grand-open-banner.95d8daa.jpg";